'use client';

export { default } from './TablePagination';
export { default as tablePaginationClasses } from './tablePaginationClasses';
export * from './tablePaginationClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TablePagination/index.js
// module id = 598
// module chunks = 25